export default __webpack_public_path__ + "a1a6b3db44181ecb7b704a4c378b1604.svg";